import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import PriceTag from "./PricePlans/PriceTag";
import ThreeBtn from "./PricePlans/ThreeBtn";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Zoom,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import userService from "../services/userService";

function Subscription({
  price_detail,
  planName,
  planList,
  btn_list,
  plan_mode,
  hide,
  currentUser,
  plan_id,
  defaultPlan,
}) {
  const [planPeriod, setplanPeriod] = useState(null);
  const [currentPlan, setCurrentPlan] = useState();
  const [currentplancheck,setCurrentplancheck] = useState(false);
  const userDetails = useSelector((user) => user);
  
  let isCurrentPlan;

  useEffect(() => {
    if (planPeriod) {
      console.log(planPeriod, "planPeriod");
    }
  }, [planPeriod]);

  useEffect(async () => {
    // if (currentPlan) {
    //   console.log(currentUser, currentPlan, "currentUser");
    //   isCurrentPlan =
    //     currentUser?.planName === planName &&
    //     !currentUser?.isAdmin &&
    //     hide !== true;
    // } else {
    // }
    let params = userDetails.user.currentUser.email
    let res = await userService.getUserProfile(params);
     let userData = res.data.user
     console.log("userData_",userData)
    setCurrentPlan(userData.plan.name)
  }, [currentplancheck]);
  isCurrentPlan =  currentPlan === planName && !currentUser?.isAdmin && hide !== true;
  // isCurrentPlan =
  //   currentUser?.planName === planName &&
  //   !currentUser?.isAdmin &&
  //   hide !== true;

  console.log("isCurrentPlan_", currentUser, planName);
  return (
    <Zoom in={true} style={{ transitionDelay: "100ms" }}>
      <Card
        elevation={isCurrentPlan ? 12 : 4}
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          borderRadius: 4,
          transition: "all 0.3s ease-in-out",
          position: "relative",
          overflow: "visible",
          border: isCurrentPlan
            ? "4px solid #667eea"
            : "1px solid rgba(0,0,0,0.12)",
          background: isCurrentPlan
            ? "linear-gradient(145deg, #ffffff 0%, #e8eeff 100%)"
            : "white",
          transform: isCurrentPlan ? "scale(1.05)" : "scale(1)",
          zIndex: isCurrentPlan ? 2 : 1,
          "&:hover": {
            transform: isCurrentPlan
              ? "scale(1.05) translateY(-8px)"
              : "translateY(-8px)",
            boxShadow: isCurrentPlan
              ? "0 20px 60px rgba(102, 126, 234, 0.5)"
              : "0 12px 40px rgba(102, 126, 234, 0.3)",
          },
        }}
      >
        {isCurrentPlan && (
          <Box
            sx={{
              position: "absolute",
              top: -20,
              left: "50%",
              transform: "translateX(-50%)",
              bgcolor: "#ee942dff",
              color: "white",
              px: 4,
              py: 1,
              borderRadius: 3,
              fontSize: "14px",
              fontWeight: 700,
              boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
              zIndex: 3,
              whiteSpace: "nowrap",
              letterSpacing: "1px",
            }}
          >
            CURRENT PLAN
          </Box>
        )}

        <CardContent
          sx={{
            p: 3,
            pt: isCurrentPlan ? 5 : 3,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          {/* Plan Name - Fixed height */}
          <Box
            sx={{
              minHeight: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                fontWeight: 700,
                color: isCurrentPlan ? "#667eea" : "#1a1a2e",
                fontSize: "1.5rem",
              }}
            >
              {planName}
            </Typography>
          </Box>

          {/* Period Selector - Fixed height */}
          <Box
            sx={{
              minHeight: "50px",
              mb: 2,
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {!defaultPlan && (
              <ThreeBtn
                btn_list={btn_list}
                planPeriod={(period) => setplanPeriod(period)}
                pricebox={true}
              />
            )}
          </Box>

          {/* Price Tag - Flexible but contained */}
          <Box sx={{ flexGrow: 1, mb: 2, overflow: "hidden", width: "100%" }}>
            <PriceTag
              price_detail={price_detail}
              planPeriod={planPeriod}
              planName={planName}
              planList={planList}
              plan_mode={plan_mode}
              bg_color={"bg-white"}
              price_size={"50px"}
              hide={hide}
              plan_id={plan_id}
              defaultPlan={defaultPlan}
              isCurrentPlan={isCurrentPlan}
              setCurrentPlan={setCurrentPlan}
              setCurrentplancheck={setCurrentplancheck}
            />
          </Box>

          {/* Learn More Button - Fixed at bottom */}
          <Box sx={{ mt: "auto", width: "100%" }}>
            <Button
              component={Link}
              to={{ pathname: hide ? "/homepricedetails" : "/pricedetails" }}
              variant="outlined"
              fullWidth
              startIcon={<InfoIcon />}
              sx={{
                borderRadius: 3,
                textTransform: "none",
                py: 1.5,
                fontWeight: 600,
                borderWidth: 2,
                borderColor: isCurrentPlan ? "#667eea" : "primary.main",
                color: isCurrentPlan ? "#667eea" : "primary.main",
                "&:hover": {
                  borderWidth: 2,
                  transform: "scale(1.02)",
                  borderColor: isCurrentPlan ? "#667eea" : "primary.main",
                  bgcolor: isCurrentPlan
                    ? "rgba(102, 126, 234, 0.1)"
                    : "rgba(25, 118, 210, 0.04)",
                },
              }}
            >
              Learn more
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Zoom>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(mapStateToProps)(withRouter(Subscription));
